import { render, staticRenderFns } from "./MaintainStockFormEdit.vue?vue&type=template&id=812f0440&"
import script from "./MaintainStockFormEdit.vue?vue&type=script&lang=js&"
export * from "./MaintainStockFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports